import { Icon } from '@/components/Icon'
import { RawButton } from '@/components/Button'
import { Tooltip } from '@/components/Tooltip'
import { externalLinks } from '@/utils/link'
import styles from './TxfJobCard.module.css'

export interface TxfJobCardProps {
  onViewInTxf: () => unknown
}

export function TxfJobCard({ onViewInTxf }: TxfJobCardProps) {
  return (
    <div className={styles.root}>
      <Icon name="txf" size={32} />

      <div className={styles.title}>Documents have been extracted</div>

      <div className={styles.description}>
        Review the extracted information and export to supported tax software.{' '}
        For more information, check out our{' '}
        <a
          href={externalLinks.txfIntelligenceWebinar()}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.resourceCenterLink}
        >
          Resource Center
        </a>
        .{' '}
        <Tooltip
          placement="top"
          content="TXF only supports individual (1040) returns via ProConnect and Drake. Business returns may be misclassified as Schedule C."
        >
          <Icon name="info-blue" size={14} color="var(--red400)" />
        </Tooltip>
      </div>

      <RawButton className={styles.button} onPress={onViewInTxf}>
        Review & Export
      </RawButton>
    </div>
  )
}
